import { DeliveryAddress } from "./delivery-address";
import { Product } from "./product";

export class OrderSummary {
    product: Product;
    pincode: any;
    deliveryAddress: DeliveryAddress;
}